import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { tap } from "rxjs";
import { AppSettings } from "../models/config.models";

@Injectable({
  providedIn: 'root'
})

export class ConfigService {
  private settings?: AppSettings;
  private readonly apiConfigFile = 'apiconfig.json'

  constructor(
    private httpClient: HttpClient
  ){}

  get careersSitesApi() {
    return this.settings?.careersSitesApi;
  }

  get referencingApiUrl() {
    return this.settings?.referencingApiUrl;
  }

  get onboardingApiUrl() {
    return this.settings?.onboardingApiUrl;
  }

  get interviewSchedulerApiUrl() {
    return this.settings?.interviewSchedulerApiUrl;
  }

  public loadSettings(){
    return this.httpClient
    .get(this.apiConfigFile)
    .pipe(
      tap(returnedConfig => {
        this.settings = returnedConfig as AppSettings
      })
    ).toPromise();
  }
}
